import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M6.195 3.529c.26-.26.683-.26.943 0 .26.26.26.682 0 .942L4.276 7.332l9.057.001c.335 0 .612.247.66.568L14 8c0 .368-.298.667-.667.667H4.276l2.862 2.862c.234.234.258.6.07.86l-.07.082c-.26.26-.682.26-.943 0l-4-4-.015-.015-.038-.044c-.01-.013-.02-.026-.028-.039-.01-.014-.02-.03-.028-.045l-.019-.036c-.023-.047-.04-.097-.052-.15-.021-.098-.02-.2.004-.298l.01-.042.01-.025c.008-.025.018-.05.03-.073l.01-.02.035-.058c.024-.034.05-.067.081-.097l-.05.056c.012-.015.024-.029.037-.042l.013-.014z"
	})
});
export default SvgArrowLeft;
